import React, { useContext, useState } from 'react';
import { Main, Body, Header } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { NecttosContext } from '../../context/NecttosContext';
import Input2 from '../../NecttosComp/Input/Input2';

async function backToPreviousVerification(userId, keyDataBack) {
	const instance = await getAxiosTokenInstance();
	const { data } = await instance.post('/college/admissionProcess2/revertToBackAdmission', { userId, keyDataBack });
	return data;
}

function Rewardback({ userId, isStudent, keyData, refectData, TimerFunction, startDateTimer, onClose, parentOnClose, state, keyDataBack, setState }) {
	const { profile, collegeId } = useContext(NecttosContext);
	const [acknowledged, setAcknowledged] = useState(false);
	const [loading, setLoading] = useState(false);
	
	// Initialize remarks state similar to React Native version
	const [remarks, setRemarks] = useState({
		remarks: `Reverted back from ${keyDataBack} because of`,
		calculatedIndex: ''
	});

	const handleSubmit = async () => {
		if (!acknowledged) return;
		setLoading(true);

		try {
			const instance = await getAxiosTokenInstance();

			// Step 1: Submit remark
			await instance.post('/college/admissionProcess2/editupdateProfile', {
				userId,
				collegeId,
				profile: {
					remarks: remarks?.remarks || `Reverted back from ${keyData}`,
					calculatedIndex: remarks?.calculatedIndex || '',
				},
			});

			// Step 2: Revert back
			await backToPreviousVerification(userId, keyDataBack);

			setState({ ...state, verified: true });
			refectData();
			parentOnClose();
		} catch (error) {
			console.error('Error during verification:', error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Main width={'50%'} height={'65%'} title='Confirm Revert Back'>
			<Header>
				<div>
					<TimerFunction start={true} date={startDateTimer} className='text-xl font-mono w-full text-center rounded-lg p-3 ml-1 h-[40px] flex justify-center items-center dark:bg-neutral-700 dark:text-slate-100 bg-slate-100 text-slate-800' />
				</div>
				<div className='flex justify-end'>
					<Button type='close' onClick={onClose}>
						close
					</Button>
				</div>
			</Header>

			<Body>
				<div className='w-full max-w-5xl mx-auto flex flex-col lg:flex-row items-center lg:items-start gap-8 p-6 rounded-2xl'>
					<div className='flex-shrink-0 flex flex-col items-center lg:items-start p-6'>
						<img src={profile?.photoURL} alt='Profile' className='w-32 h-32 sm:w-36 sm:h-36 rounded-xl object-cover border-3 border-emerald-500 shadow-md mb-4 transition-transform hover:scale-105' />
						<h2 className='text-xl font-bold text-gray-900 dark:text-white text-center lg:text-left mb-1'>{profile?.name}</h2>
						<p className='text-sm font-medium text-gray-600 dark:text-gray-300 text-center lg:text-left px-3 py-1 bg-blue-50 dark:bg-blue-900/20 rounded-full'>Department of Mathematics</p>
					</div>

					<div className='flex flex-col justify-center lg:justify-start items-center lg:items-start gap-8 flex-1 w-full mt-5'>
					
						<Input2 
							type='text' 
							placeholder='Write remarks'
							state={remarks}
							setState={setRemarks}
							returnKey='remarks'
							className='w-full'
							fieldName='Add Remarks'
							max={100}
						/>

						

						<div className='flex items-start gap-4 text-base'>
							<input type='checkbox' id='acknowledge' className='w-5 h-5 mt-0.5 rounded border-2' checked={acknowledged} onChange={() => setAcknowledged(!acknowledged)} />
							<label htmlFor='acknowledge' className='cursor-pointer select-none font-medium leading-relaxed text-neutral-800 dark:text-neutral-50'>
								I acknowledge that this person needs to be reverted back to their previous status
							</label>
						</div>

						<Button width='100%' height='50px' type='verify' onClick={handleSubmit} loading={loading} disabled={!acknowledged} className='w-full sm:w-80 font-semibold text-lg shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200'>
							Yes, Verify and Complete
						</Button>
					</div>
				</div>
			</Body>
		</Main>
	);
}

export default Rewardback;